/**
 * SafePassage - Entry Point
 * Decision-Consequence Simulation for Road Safety
 */

import { app } from '@core/Application';

async function main() {
  const container = document.getElementById('app');

  if (!container) {
    console.error('App container not found');
    return;
  }

  try {
    // Initialize the application
    await app.init(container);

    // Start the experience
    await app.start();

    console.log('SafePassage initialized successfully');
  } catch (error) {
    console.error('Failed to initialize SafePassage:', error);

    // Show error to user
    const loading = document.getElementById('loading');
    if (loading) {
      loading.innerHTML = `
        <p style="color: #ef4444;">Failed to load SafePassage</p>
        <p style="font-size: 0.875rem; color: #888;">Please refresh the page to try again</p>
      `;
    }
  }
}

// Start when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {
  main();
}
